import { useEffect, useState } from "react";
import { useI18n } from "@/i18n";
import { fetchCategories } from "./api";
import type { CategoryRef, Product } from "@/types";

/** Showcase categories for tabs (only those with products), refreshed with the language. */
export function useCategories(): CategoryRef[] | null {
  const { locale } = useI18n();
  const [list, setList] = useState<CategoryRef[] | null>(null);
  useEffect(() => {
    fetchCategories().then(setList).catch(() => setList([]));
  }, [locale]);
  return list;
}

/** Does a product belong to a showcase category (by slug)? Older data falls back to the type. */
export function inCategory(p: Product, slug: string): boolean {
  return p.categoryRef ? p.categoryRef.slug === slug : p.category === slug;
}

/** Label for the small eyebrow over a product ("Кофе", "Дрип-кофе"…). */
export function categoryLabel(p: Product, t: (k: string) => string): string {
  return p.categoryRef?.name || t(`catalog.categories.${p.category}`);
}
